import { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import {
  addUserToProject,
  getParticipants,
  removeCollaborator,
} from '../../api/constlink';
import AddPartnersModal from '../../components/partners/AddPartnersModal';
import CollaboratorListComponent from '../../components/partners/CollaboratorListComponent';
import { User } from '../../modules/auth';

interface CollaboratorListContainerProps {
  enterpriseId: string;
  projectId: string;
}
function CollaboratorListContainer({
  match,
  history,
}: RouteComponentProps<CollaboratorListContainerProps>) {
  const { enterpriseId, projectId } = match.params;
  const [visible, setVisible] = useState(false);
  const [collaborators, setCollaborators] = useState<User[]>();
  useEffect(() => {
    (async () => {
      setCollaborators(await getParticipants(enterpriseId, projectId));
    })();
  }, [enterpriseId, projectId]);

  const _onDelete = (userId: string) => {
    (async () => {
      await removeCollaborator(enterpriseId, projectId, userId);
      setCollaborators(collaborators?.filter((item) => item.id !== +userId));
    })();
  };

  const addCollaborators = () => setVisible(true);

  const onCreate = async (userIdList: number[]) => {
    await addUserToProject(enterpriseId, projectId!, userIdList);
    setVisible(false);
    (async () => {
      setCollaborators(await getParticipants(enterpriseId, projectId));
    })();
  };

  let onDelete;
  if (projectId) onDelete = _onDelete;
  return (
    <>
      {collaborators && (
        <CollaboratorListComponent
          isProjectLevel={projectId !== undefined}
          collaborators={collaborators}
          addCollaborators={addCollaborators}
          onDelete={onDelete}
        />
      )}
      {collaborators && (
        <AddPartnersModal
          visible={visible}
          enterpriseId={enterpriseId}
          projectId={projectId}
          existingCollaborators={collaborators}
          onCreate={onCreate}
          onCancel={() => {
            setVisible(false);
          }}
        />
      )}
    </>
  );
}

export default CollaboratorListContainer;
